export const VERSION = '4.17.4'; // x-release-please-version
//# sourceMappingURL=version.mjs.map